export default __webpack_public_path__ + "static/media/slack.e2fce380.svg";